import { forwardRef } from 'react';
import { Icon } from '@chakra-ui/react';
import { QIconProps } from './Icon';
import { QTheme } from '../QTheme';

export const ResourceComplianceGap = forwardRef<
  SVGSVGElement,
  Partial<QIconProps>
>((props, ref) => {
  return (
    <Icon viewBox="0 0 16 16" color="currentColor" {...props} ref={ref}>
      <svg fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <rect width="16" height="16" rx="3" fill={QTheme.colors.gray[100]} />
        <path
          d="m5.5 4.5v8"
          stroke={QTheme.colors.gray[700]}
          strokeLinecap="round"
        />
        <path
          d="m5.5 4.5h6l-1 2.5 1 2.5h-6"
          fill="none"
          stroke={QTheme.colors.gray[700]}
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
});

ResourceComplianceGap.displayName = 'ResourceComplianceGap';
